import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { refreshCoveragePackagePricesAtom } from '../atoms/refreshCoveragePackagePricesAtom';
import { coveragePackagesSelector } from './coveragePackagesSelector';
import { isSavingPackageAtom } from '../atoms/isSavingPackageAtom';

export const coveragePackagePriceSelector = selector({
    key: 'coveragePackagePriceSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        get(refreshCoveragePackagePricesAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const isSavingPackage = get(isSavingPackageAtom);
        if (!currentProduct || isSavingPackage) {
            return [];
        }

        const { lobCode, fixedId } = currentProduct;

        const packages = get(coveragePackagesSelector);

        const prices = await OnlineSalesUnauthenticated.getPackagePrices(
            jobNumber,
            lobCode,
            fixedId,
            sessionId,
            !isLoggedOn
        );

        return packages.map((pack) => ({
            ...pack,
            price: prices.find((price) => price.branchNumber === pack.branchNumber)?.price
        }));
    }
});
